import { useFeatureImportanceFilterDropdownMutation, 
    useFeatureImportanceLineChartMutation, 
    useFeatureImportanceTableDataMutation } 
from "../api/featureImportanceApi";

export const useFeatureImportanceFilterDropdown=()=>{
    const [mutate, {isLoading, isError, isSuccess, error, data}] = useFeatureImportanceFilterDropdownMutation();
    return {
        mutate,
        isLoading,
        isError,
        isSuccess,
        error,
        data
    }
}

export const useFeatureImportanceLineChart=()=>{
    const [mutate, {isLoading, isError, isSuccess, error, data}] = useFeatureImportanceLineChartMutation();
    return {
        mutate,
        isLoading,
        isError,
        isSuccess,
        error,
        data
    }
}

export const useFeatureImportanceTableData=()=>{
    const [mutate, {isLoading, isError, isSuccess, error, data}] = useFeatureImportanceTableDataMutation();
    return {
        mutate,
        isLoading,
        isError,
        isSuccess,
        error,
        data,
    }
}